<div class="modal-customized new-admin">
  <div class="modal-title">
    <h3>
      <!-- <span class="icon-pencil"></span> -->
      <i class="fa-solid fa-pencil"></i>
      {{ this.data.modal.title }}
    </h3>
    <span class="fa fa-times modal-close" (click)="closeDialog()" data-dismiss="modal"></span>
  </div>

  <div class="modal-content">
    <div class="controls">
      <div class="to-left"><!-- Empty --></div>
      <div class="to-right">
        <p class="required"><i>*</i>Required fields</p>
      </div>
    </div>

    <mat-grid-list class="rows-request" cols="2" rowHeight="78px">
      <ng-container *ngFor="let field of data.modal.fields; let i = index; let last = last">
        <mat-grid-tile [colspan]="getFieldColspan(i)">
          <mat-form-field
            class="setup-field"
            appearance="outline"
            [ngClass]="{
              'short-name-error':
                field.value && field.title === 'Short Name' && field.value.length !== 2 && shortNameError,
              'input-disabled': field.title === 'Short Name'
            }"
            (keyup)="field.title === 'User Name' && field.value === '' ? (shortNameError = '') : null"
          >
            <mat-label>{{ field.title }}</mat-label>
            <input
              matInput
              placeholder="{{ field.title }}"
              [(ngModel)]="field.value"
              [disabled]="field.title === 'Short Name' ? true : false"
              (ngModelChange)="field.title === 'User Name' ? updateShortName(field.value) : null"
              [value]="field.title === 'Short Name' ? shortName : ''"
              required
            />
            <mat-error *ngIf="!field.value">This field is required</mat-error>
            <mat-hint class="mat-error" *ngIf="field.value && field.title === 'Short Name' && field.value.length !== 2">
              {{ shortNameError }}
            </mat-hint>
          </mat-form-field>
        </mat-grid-tile>
      </ng-container>
    </mat-grid-list>

    <div *ngFor="let toggle of data.modal.toggles" class="slide-div">
      <span>{{ toggle.title }}</span>
      <mat-slide-toggle class="custom-slide-toggle" [disabled]="toggle.disabled" [(ngModel)]="toggle.value"
        >ACTIVE</mat-slide-toggle
      >
    </div>
  </div>
</div>
<div class="actions">
  <div class="label-actions" mat-dialog-actions>
    <div class="creation">
      <span *ngFor="let label of data.modal.labels"
        >{{ label.title }}: <b>{{ label.value }}</b></span
      >
    </div>
  </div>

  <div *ngIf="!editMode" class="btn-actions" mat-dialog-actions>
    <button
      *ngFor="let btnEdit of data.modal.button_edit"
      (click)="actionEdit(btnEdit)"
      [disabled]="compareAcess(btnEdit?.required)"
      class="{{ btnEdit.class }}"
      mat-stroked-button
      color="primary"
    >
      <mat-icon *ngIf="btnEdit.class === 'button-edit'">edit</mat-icon> {{ btnEdit.title }}
    </button>
  </div>

  <div *ngIf="editMode" class="btn-actions" mat-dialog-actions>
    <button
      *ngFor="let btnEdit of this.action"
      (click)="actionEdit(btnEdit)"
      class="{{ btnEdit.class }}"
      mat-stroked-button
      color="primary"
    >
      {{ btnEdit.title }}
    </button>
  </div>
</div>
